<template>
    <div class="content-wrap" v-if="fvg">
        <div class="box">
            <!-- user -->
            <div class="box-user">
                <div class="box-user-left">
                    <img v-if="userinfo.gender == 2" src="@/assets/images/service/woman.png" alt="" />
                    <img v-else src="@/assets/images/service/man.png" alt="" />
                </div>
                <div class="box-user-cen">
                    <div class="user-top">
                        <div class="font-tex3">{{userinfo.user_name}}</div>
                        <!-- <img src="~@/assets/images/user/house/user_vip1_img.png" alt=""> -->
                        <div class="title">{{userinfo.project_name}}</div>
                    </div>
                    <div class="font-text1 omit user-bot">
                        {{userinfo.useraddress}}
                    </div>
                </div>
                <div class="box-user-right">
                    <div>{{service[0].score}}</div>
                    <div class="font-text1">综合得分</div>
                </div>
            </div>
            <!-- time -->
            <div class="box-time">
                <div class="font-text1 time-bot timebox">
                    <span>合同号：{{userinfo.contract_code}}</span>
                    <span>联系电话：{{userinfo.user_phone}}</span>
                </div>
                <div class="border-bottom">
                    <img
                        src="@/assets/images/service/border-bottom.png"
                        alt=""
                    />
                </div>
                <div class="time-bot-start timebox">
                    <span>开工时间：{{userinfo.start_date.substring(0,10)}}</span>
                    <span>完工时间：{{userinfo.finish_date.substring(0,10)}}</span>
                </div>
                <div class="border-bottom">
                    <img
                        src="@/assets/images/service/border-bottom.png"
                        alt=""
                    />
                </div>
                <div class="time-bot-start timebox">
                    <span>锅炉台数：{{parseInt(userinfo.boiler_num)}}</span>
                    <span>地暖面积：{{userinfo.floor_warm_area}}㎡</span>
                </div>
                <div class="border-bottom">
                    <img
                        src="@/assets/images/service/border-bottom.png"
                        alt=""
                    />
                </div>
                <div class="time-bot-start timebox">
                    <span>暖气片组数：{{parseInt(userinfo.heating_radiator)}}</span>
                    <span>风机盘管组数：{{parseInt(userinfo.wind_machine_num)}}</span>
                </div>
                <div class="solid-line"></div>
                <div class="person">
                    <span>签单手：{{userinfo.project_salesperson}}</span>
                    <span>项目经理：{{userinfo.project_manager}}</span>
                    <span>监理：{{userinfo.project_supervisor}}</span>
                </div>
            </div>
        </div>
        <!--路由导航-->
        <div class="nav-container-view">
            <div
                class="nav-item"
                :class="{ 'active-nav-item': nav.active }"
                @click="navToRouter(index)"
                v-for="(nav,index) in arrNavList"
                :key="nav.path"
            >
                {{ nav.name }}
            </div>
            <div
                class="liner-to-left"
                :class="{ 'liner-to-right': arrNavList[1].active }"
            ></div>
        </div>
        <keep-alive>
            <router-view @change="change"></router-view>
        </keep-alive>

        <!-- 悬浮按钮 -->
        <Drag></Drag>
    </div>
</template>

<script>
import Drag from "../components/drag.vue";
import store from "@/store/store";

export default {
    name: "index",
    components: {
        Drag,
    },
    data() {
        return {
            fvg: false,
            arrNavList: [
                {
                    name: "服务商得分数据分析",
                    path: "/service/scoredetail/index",
                    active: true,
                },
                {
                    name: "服务问题分析",
                    path: "/service/scoredetail/questionanalysis",
                }
            ],
        };
    },
    created(){
        $init (() => {
            this.$store.commit("loadSwitch", true);
            let contract_id = this.$route.query.id;
            this.$store.dispatch('serviceScoreDetail/getData',{contract_id}).then (() => {
                this.$store.commit("loadSwitch", false);
                this.fvg = true
            })
        })
    },
    computed:{
        userinfo() {
            console.log(this.$store.state.serviceScoreDetail.userinfo,'userinfo');
            return this.$store.state.serviceScoreDetail.userinfo
        },
        service() {
            console.log(this.$store.state.serviceScoreDetail.service,'service');
            return this.$store.state.serviceScoreDetail.service
        }
    },
    methods: {
        change () {
            this.$set(this.arrNavList[1],'active',true)
            this.$set(this.arrNavList[0],'active',false)
            let project_name = this.$route.query.name || ''
            let id = this.$route.query.id
            this.$store.dispatch({type:'serviceScoreDetail/getScoreData',project_name:project_name,contract_id:id}).then (() => {
                this.$store.commit("loadSwitch", false);
            })
        },
        navToRouter(index) {
            this.arrNavList = this.arrNavList.map((i,idx) => {
                i.active = false;
                if (index == idx ) {
                    i.active = true
                }
                return i;
            });
            // 跳转
            let contract_id = this.$store.state.serviceScoreDetail.contract_id
            let path = this.arrNavList[index].path
            if (index == 0) {
                path += '?id='+ contract_id
            } else if (index == 1){
                path += '?id='+ contract_id + '&name=' + ''
                this.$store.dispatch({type:'serviceScoreDetail/getScoreData',project_name:'',contract_id:contract_id}).then (() => {
                    this.$store.commit("loadSwitch", false);
                })
            }
            this.$router.push(path);
        },
    },
};
</script>

<style lang="scss" scoped>
.content-wrap {
    min-height: 100vh;
    background: #f0f4f1;
    position: relative;
    overflow: hidden;

    .box {
        width: 93.6%;
        margin: 24px auto 56px;
        padding: 28px 24px 0 24px;
        background: $divBg;
        border-radius: 12px;

        .box-user {
            display: flex;
            align-items: center;
            padding-bottom: 24px;
            border-bottom: 1px solid rgba(245, 245, 245, 1);

            .box-user-left {
                width: 84px;
                height: 84px;
                border-radius: 50%;
                margin-left: 4px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .box-user-cen {
                padding-left: 20px;
                flex: 1;

                .user-top {
                    display: flex;
                    align-items: center;
                    padding-bottom: 8px;

                    font-tex3 {
                        color: $deepGreen;
                        font-size: 20px;
                    }
                    .title {
                        padding: 2px 20px;
                        margin-left: 22px;
                        background: #318544;
                        border-radius: 4px 16px 4px 16px;
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        line-height: 32px;
                    }

                    // img {
                    //     margin-left: 12px;
                    //     width: 92px;
                    //     height: 40px;
                    // }
                }

                .user-bot {
                    max-width: 350px;
                    color: $comText1;
                }
            }

            .box-user-right {
                text-align: center;
                color: $deepGreen;

                div:first-of-type {
                    font-size: 52px;
                    font-weight: 500;

                    height: 84px;
                    line-height: 84px;
                }

                div:last-of-type {
                    margin-top: -16px;
                }
            }
        }

        .box-time {
            padding-top: 22px;
            padding-bottom:24px ;

            // .time-top {
            //     display: flex;
            //     align-items: center;
            //     justify-content: space-between;
            //     margin-bottom: 20px;
            //     div {
            //         line-height: 40px;
            //     }
            // }

            .time-bot {
                color: $comText1;
                font-size: 24px !important;
                color: #858585;
                padding: 0 38px 20px 0;
            }
            .timebox {
                display: flex;
                span:first-child {
                    flex: 1;
                }
                span:last-child {
                    width: 270px;
                    text-align: left;
                }
            }
            .time-bot-start {
                color: $comText1;
                font-size: 24px !important;
                font-weight: 400;
                padding: 18px 38px 20px 0;
            }
            .border-bottom {
                width: 654px;
                height: 2px;
                img {
                    width: 654px;
                    height: 2px;
                }
            }
            .solid-line {
                width: 654px;
                height: 2px;
                background-color: #f1f1f1;
            }
            .person {
                padding-top: 22px;
                display: flex;
                justify-content: space-between;
                width: 100%;
                span {
                    font-size: 24px;
                    font-weight: 500;
                    color: #444444;
                    line-height: 34px;
                }
            }
        }
    }

    .nav-container-view {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 16px;
        position: relative;
        margin-bottom: 24px;

        .liner-to-left {
            position: absolute;
            width: 140px;
            height: 6px;
            bottom: 0;
            left: 104px;
            background: $deepGreen;
            transition: all 0.5s;
        }

        .liner-to-right {
            left: calc(100% - 140px - 104px);
        }

        .nav-item {
            flex: 1;
            font-size: $bigSize;
            text-align: center;
            line-height: 44px;
            color: #858585;
            font-weight: 400;
        }

        .active-nav-item {
            color: $commonText;
            font-weight: 600;
        }
    }
}

// 卡片标题字号 - 14 个样式
.font-text {
    // 28
    font-size: $baseSize;
    font-weight: 500;
}

.font-text1 {
    // 24
    font-size: $smallSize;
    font-weight: 400;
}

.font-tex2 {
    // 28
    font-size: $baseSize;
    font-weight: 400;
}

.font-tex3 {
    // 32
    font-size: $bigSize;
    font-weight: 500;
}

.font-text5 {
    // 24
    font-size: $smallSize;
    font-weight: 500;
}
</style>
